import {useState, useEffect} from 'react';
import { APIEndpoint, EndpointType, httpGet } from '../utils/apiService'
import { MCPCountsResponse } from '../models/MCP';

const apiURL =  APIEndpoint(EndpointType.MCP) + '/counts';

export const useMcpCounts = (zip: string, zips: string, city: string, county: string, state: string, hideBlanks: boolean, refreshKey: number, customerID: string) => {
    const [listCounts, setMylistCounts] = useState<MCPCountsResponse>({} as MCPCountsResponse);
    const [listCountError, setError] = useState("")
    const [listCountLoading, setLoading] = useState(false)

    const parseZips = (zips: string) => {
        // Replace commas with spaces and split the string into an array
        const listCountsArray = zips.replace(/,/g, ' ').split(/\s+/);

        // Remove any empty strings from the array
        const filteredlistCounts = listCountsArray.filter((listCount) => listCount.trim() !== '');

        return filteredlistCounts.join(",")
    }

    useEffect(() => {
        let params: string[] = []
        let validQuery = false;

        if (zip) {
            params.push('zip=' + zip);
            validQuery = true;
        }

        if (zips) {
            params.push('zips=' + parseZips(zips));
            validQuery = true;
        }

        if (city) {
            params = []
            params.push('city=' + city.toLocaleLowerCase().trim());
            params.push('state=' + state);
            validQuery = true;  
        }

        if (county) {
            params = []
            params.push('county=' + county.toLocaleLowerCase().trim());
            params.push('state=' + state);
            validQuery = true;
        }

        if (customerID) {
            params.push('customer_id=' + customerID);
        }

        if (!validQuery) {
            // const emptyCount: MCPListCount[] = [];
            // setMylistCounts(emptyCount);
            return;
        }

        if (hideBlanks) {
            params.push('hideblanks=true')
        }

        // build the querystring
        const queryString = "?" + params.join("&")
        
        setLoading(true)
        setError("")
        httpGet(apiURL + queryString)
            .then((data) => {
                const listCountCountsResponse = data as MCPCountsResponse;
                
                if (listCountCountsResponse.errorMessage && listCountCountsResponse.errorMessage !== '') {
                    setError(listCountCountsResponse.errorMessage)
                    setMylistCounts({} as MCPCountsResponse);
                } else {
                    if (listCountCountsResponse.counts && listCountCountsResponse.counts.length > 0) {
                        setMylistCounts(listCountCountsResponse);
                    } else {
                        setMylistCounts({} as MCPCountsResponse);
                    }
                }
            })
            .catch((error) => setError(error))
            .finally(() => setLoading(false))

    }, [zip, zips, city, county, state, refreshKey]);

    return { listCounts, listCountLoading, listCountError };
};